import { Form, Formik } from "formik";
import { BsUpload } from "react-icons/bs";
import { LiaTimesSolid } from "react-icons/lia";
import Loading from "../../../components/loading/Loading";
import {
    CONNECTION_PHASE_OPTIONS,
    FOLLOWUP_TYPE_OPTIONS,
    PROPOSAL_STAGE_OPTIONS,
    ROOF_TYPE_OPTIONS,
    VISIT_TYPE_OPTIONS,
    YES_NO_OPTIONS,
} from "../../../constants/proposalConstants";
import P from "../../../shared/typography/P";
import Button from "../../../shared/ui/Button";
import DateTimePickerBlockFormik from "../../../shared/ui/Form/DateTimePickerBlockFormik";
import FormikCheckbox from "../../../shared/ui/Form/FormikCheckBox";
import FormikLabeledInput from "../../../shared/ui/Form/FormikLabeledInput";
import FormikLabeledTextArea from "../../../shared/ui/Form/FormikLabeledTextArea";
import { FormRadioGroup } from "../../../shared/ui/Form/FormRadioGroup";
import LabeledFormikSelect from "../../../shared/ui/Form/LabeledFormikSelect";
import {
    followUpNotesFormSchema,
    freshNotesFormSchema,
    notesFormStep1Schema,
} from "../../../shared/ui/Form/schema";
import { renderFileIcons } from "../../../utils/fileUtils";

const NotesForm = ({
    onSuccess,
    handleFileUpload,
    file,
    uploading,
    removeFile,
    notesFormStep,
    setNotesFormStep,
    notesStep1Data,
    setNotesStep1Data,
}) => {
    const now = new Date();
    const twoWeeksInMillis = 14 * 24 * 60 * 60 * 1000;

    const minDate = new Date(now.getTime() - twoWeeksInMillis);
    const maxDate = new Date(now.getTime() + twoWeeksInMillis);
    return (
        <div className="px-4 py-2 h-full font-vietnam bg-white">
            {notesFormStep === 1 ? (
                <Formik
                    enableReinitialize
                    initialValues={{
                        visitType: "FRESH",
                        date: new Date(),
                        hour: 10,
                        minutes: 0,
                    }}
                    validationSchema={notesFormStep1Schema}
                    onSubmit={(values) => {
                        setNotesStep1Data(values);
                        setNotesFormStep(2);
                    }}
                >
                    <Form className="flex flex-col gap-2">
                        <LabeledFormikSelect
                            name="visitType"
                            label="Visit Type"
                            wrapperClassName={"mb-0"}
                            options={VISIT_TYPE_OPTIONS}
                            required
                        />
                        <DateTimePickerBlockFormik
                            label="Meeting Date"
                            dateName="date"
                            hourName="hour"
                            minuteName="minutes"
                            maxDate={maxDate}
                            minDate={minDate}
                        />
                        <Button type="submit" className="w-full">
                            Next
                        </Button>
                    </Form>
                </Formik>
            ) : (
                <Formik
                    enableReinitialize
                    initialValues={
                        notesStep1Data.visitType === "FRESH"
                            ? {
                                  panelBrand: "",
                                  inverterName: "",
                                  connectionPhase: "Single",
                                  hasLoadEnhancement: "yes",
                                  roofType: "RCC",
                                  hasLoanRequirement: "yes",
                                  isSubsidy: "yes",
                                  hasElevatedStructure: "yes",
                                  customerComment: "",
                                  isPanelBrandNotReqired: false,
                                  isInverterNameNotRequired: false,
                                  isBillNotAvailable: true,
                              }
                            : {
                                  followupType: "REQUIREMENT",
                                  message: "",
                                  actionTaken: "",
                                  proposalStage: "HOT",
                              }
                    }
                    validationSchema={
                        notesStep1Data.visitType === "FRESH"
                            ? freshNotesFormSchema
                            : followUpNotesFormSchema
                    }
                    onSubmit={(values) => {
                        onSuccess({ ...notesStep1Data, ...values });
                    }}
                >
                    {({ values, setFieldValue }) => (
                        <Form className="flex flex-col gap-1.5">
                            {notesStep1Data.visitType === "FRESH" ? (
                                <>
                                    <div className="flex flex-col gap-1">
                                        <FormikLabeledInput
                                            name="panelBrand"
                                            label="Panel Brand"
                                            disabled={
                                                values.isPanelBrandNotReqired
                                            }
                                            required={
                                                notesStep1Data.visitType ===
                                                "Fresh"
                                            }
                                        />
                                        <FormikCheckbox
                                            name="isPanelBrandNotReqired"
                                            label="No Specific panel requirement"
                                            onChange={(e) => {
                                                if (!e) {
                                                    setFieldValue(
                                                        "panelBrand",
                                                        "Not Required"
                                                    );
                                                } else {
                                                    setFieldValue(
                                                        "panelBrand",
                                                        ""
                                                    );
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="flex flex-col gap-1 my-1">
                                        <FormikLabeledInput
                                            name="inverterName"
                                            label="Inverter"
                                            disabled={
                                                values.isInverterNameNotRequired
                                            }
                                            required={
                                                notesStep1Data.visitType ===
                                                "Fresh"
                                            }
                                        />
                                        <FormikCheckbox
                                            name="isInverterNameNotRequired"
                                            label="No Specific inverter requirement"
                                            onChange={(e) => {
                                                if (!e) {
                                                    setFieldValue(
                                                        "inverterName",
                                                        "Not Required"
                                                    );
                                                } else {
                                                    setFieldValue(
                                                        "inverterName",
                                                        ""
                                                    );
                                                }
                                            }}
                                        />
                                    </div>

                                    <div className="grid grid-cols-2 gap-2 mt-2">
                                        <LabeledFormikSelect
                                            name="connectionPhase"
                                            label="Connection Phase"
                                            options={CONNECTION_PHASE_OPTIONS}
                                            required={
                                                notesStep1Data.visitType ===
                                                "Fresh"
                                            }
                                        />
                                        <LabeledFormikSelect
                                            name="hasLoadEnhancement"
                                            label="Load Enhancement"
                                            options={YES_NO_OPTIONS}
                                            required={
                                                notesStep1Data.visitType ===
                                                "Fresh"
                                            }
                                        />
                                        <LabeledFormikSelect
                                            name="roofType"
                                            label="Roof Type"
                                            options={ROOF_TYPE_OPTIONS}
                                            required={
                                                notesStep1Data.visitType ===
                                                "Fresh"
                                            }
                                        />
                                        <LabeledFormikSelect
                                            name="hasLoanRequirement"
                                            label="Loan Requirement"
                                            options={YES_NO_OPTIONS}
                                            required={
                                                notesStep1Data.visitType ===
                                                "Fresh"
                                            }
                                        />
                                        <LabeledFormikSelect
                                            name="isSubsidy"
                                            label="Subsidy"
                                            options={YES_NO_OPTIONS}
                                            required={
                                                notesStep1Data.visitType ===
                                                "Fresh"
                                            }
                                        />
                                        <LabeledFormikSelect
                                            name="hasElevatedStructure"
                                            label="Elevated Structure"
                                            options={YES_NO_OPTIONS}
                                            required={
                                                notesStep1Data.visitType ===
                                                "Fresh"
                                            }
                                        />
                                    </div>
                                    <FormikLabeledInput
                                        name="customerComment"
                                        label="Customer Comment"
                                    />

                                    {/* File Upload Section */}
                                    <div className="mt-1">
                                        {uploading ? (
                                            <P className="text-center flex justify-center">
                                                <Loading />
                                            </P>
                                        ) : (
                                            <label
                                                role="button"
                                                className="border border-blue-400 rounded-lg p-0.5 px-0-0.2 w-full text-center flex items-center justify-center cursor-pointer mb-0.4"
                                                htmlFor="fileUploadInput"
                                            >
                                                <P className="flex items-center gap-0.4 xl:text-sm 2xl:text-base text-secondary">
                                                    <BsUpload />
                                                    Upload Electricity Bill
                                                </P>
                                            </label>
                                        )}
                                        <input
                                            type="file"
                                            id="fileUploadInput"
                                            name="fileUploadInput"
                                            onClick={(e) =>
                                                (e.target.value = null)
                                            }
                                            onChange={handleFileUpload}
                                            className="hidden"
                                        />
                                        <div className="flex flex-col-reverse">
                                            {file.length > 0 &&
                                                file.map((doc, index) => (
                                                    <div
                                                        key={index}
                                                        className="flex justify-between items-center border border-blue-400 bg-gray-100 rounded-lg p-1 py-0.5 mb-0.5 gap-0.2"
                                                    >
                                                        <div className="flex items-center gap-0.5">
                                                            <div className="text-xxl mr-0.5 text-gray-140 ">
                                                                {renderFileIcons(
                                                                    doc.name
                                                                )}
                                                            </div>
                                                            <P className="text-secondary xl:text-sm 2xl:text-sm truncate w-[230px] ">
                                                                {doc.name}
                                                            </P>
                                                        </div>
                                                        <button
                                                            onClick={() =>
                                                                removeFile(
                                                                    index
                                                                )
                                                            }
                                                            className="text-red-500 hover:text-red-700 text-xl"
                                                        >
                                                            <LiaTimesSolid />
                                                        </button>
                                                    </div>
                                                ))}
                                        </div>
                                        <FormikCheckbox
                                            name="isBillNotAvailable"
                                            label="Bill not available, customer will share bill later"
                                        />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <LabeledFormikSelect
                                        name="followupType"
                                        label="Follow Up Type"
                                        wrapperClassName={"mb-0"}
                                        options={FOLLOWUP_TYPE_OPTIONS}
                                        required={
                                            notesStep1Data.visitType !== "Fresh"
                                        }
                                    />
                                    <FormikLabeledTextArea
                                        name="message"
                                        label="Message"
                                        rows="2"
                                        required={
                                            notesStep1Data.visitType !== "Fresh"
                                        }
                                    />
                                    <FormikLabeledTextArea
                                        name="actionTaken"
                                        label="Action Taken"
                                        rows="2"
                                        required={
                                            notesStep1Data.visitType !== "Fresh"
                                        }
                                    />
                                    <FormRadioGroup
                                        name="proposalStage"
                                        label="Proposal Stage"
                                        wrapperClass="flex-col"
                                        options={PROPOSAL_STAGE_OPTIONS}
                                    />
                                </>
                            )}
                            <Button type="submit" className="w-full lg:mb-0">
                                Add Meeting Notes
                            </Button>
                        </Form>
                    )}
                </Formik>
            )}
        </div>
    );
};

export default NotesForm;
